import { Collapse, Divider, Input } from "antd";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DateTimeNow, ReportActivitiesEnum } from "../../../constants/constants";
import { ReviewModel } from "../../../models/review.model";
import { AppState } from "../../../redux/store";
import { DATE_UTIL } from "../../../utils/dateUtils";
import AppAvatar from "../avatar";
import { ArrowForwardIcon } from "../icon";
import "./review.scss";

const { Panel } = Collapse;

interface ReviewListProps {
    reviews: ReviewModel[];
    showInputComment?: boolean;
}

const ReviewList = (props: ReviewListProps) => (
    <React.Fragment>
        {props.reviews && props.reviews.map((item, index) =>
            <div className="review-item" key={index}>
                <div className="info">
                    <AppAvatar
                        src={item.avatar}
                        name={item.created_by}
                        size={28}
                    />
                    <div>
                        <div>
                            <b>{item.created_by}</b>
                            {(item.action === ReportActivitiesEnum.Approve || item.action === ReportActivitiesEnum.Refer) && <span>
                                &nbsp;has {
                                    item.action === ReportActivitiesEnum.Approve ? <b className="green-text">Approved</b> : <b className="red-text">Returned</b>
                                } the report.
                            </span>}
                        </div>

                        <span>{DATE_UTIL.convertServerToReviewDateTimeFormat(item.created_on)}</span>
                    </div>
                </div>

                {
                    item.action === ReportActivitiesEnum.Comment && <div className="content">
                        {item.message}
                    </div>
                }
                {
                    (index !== props.reviews.length - 1 || props.showInputComment) && <Divider />
                }

            </div>)}
    </React.Fragment>
);

interface Props {
    comment: (message: string) => void;
    data?: ReviewModel[];
    showInputComment?: boolean;
    newReview: ReviewModel | undefined;
}

const AppReview = (props: Props) => {

    const [isClose, setClose] = useState(false);
    const [value, setVale] = useState<string | undefined>(undefined);
    const [reviews, setReviews] = useState<ReviewModel[]>([]);
    const userName = useSelector((state: AppState) => state.userState.user?.username);

    const activeChange = (key: string | string[]) => {
        if (!key || !key.length) {
            setClose(true);
        } else {
            setClose(false);
        }
    }

    const inputChange = (event: ChangeEvent<HTMLInputElement>): void => {
        setVale(event.target.value);
    }

    const keyPess = (event: React.KeyboardEvent<HTMLInputElement>): void => {
        if (event.key === 'Enter' && value) {
            props.comment(value);
            setReviews(pre => [...pre,
            {
                created_by: userName,
                message: value,
                created_on: DateTimeNow,
                action: ReportActivitiesEnum.Comment
            }]);
            setVale(undefined);
        }

    }

    useEffect(() => {
        if (props.newReview) {
            setReviews(pre => [...pre, { ...props.newReview, created_by: userName }]);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.newReview])

    useEffect(() => {
        if (props.data) {
            setReviews(props.data);
        }

    }, [props.data])


    return (
        (!reviews || !reviews.length) && !props.showInputComment ? <React.Fragment>
        </React.Fragment> :
            <Collapse
                bordered={false}
                defaultActiveKey={['1']}
                expandIcon={() => <span className="arrow-item"><ArrowForwardIcon /></span>}
                onChange={(key) => { activeChange(key) }}
                className={`review-wrapper${isClose ? " closed" : ""}`}
            >
                <Panel header={<span className="review-title">{props.showInputComment ? "Start reviewing" : "Details"}</span>} key="1">
                    <div className="review-content">
                        {reviews.length > 0 && <ReviewList showInputComment={props.showInputComment} reviews={reviews} />}

                        {
                            props.showInputComment &&
                            <React.Fragment>
                                <div className="review-item no-boder">
                                    <div className="info">
                                        <AppAvatar
                                            name={userName}
                                            size={28}
                                        />
                                        <div>
                                            <b>{userName}</b>
                                        </div>
                                    </div>
                                </div>

                                <React.Fragment>
                                    <Input
                                        placeholder="Comment"
                                        onKeyPress={(e) => keyPess(e)}
                                        onChange={(e) => inputChange(e)} value={value} />
                                    <small>
                                        Press Enter to add comment.
                                    </small>
                                </React.Fragment>
                            </React.Fragment>
                        }

                    </div>
                </Panel>
            </Collapse>
    )
}

export default AppReview